//import * as actions from '../../actions/actionTypes';

const initialState = [];

export default function members(state = initialState, action) {
  switch (action.type) {
    case 'SET_MEMBERS':
      //console.log('[members][payload]', action.payload);
      if (action.payload.list) {
        return action.payload.list;
        //return [...action.payload.list];
      } else {
        return state;
      }
    default:
      return state;
  }
}
